import React, { useState, useEffect } from 'react'
import Layout from '../../common/layout/layout'
import { Row, Col, Button } from 'react-bootstrap'
import { useParams, useHistory } from 'react-router'
import { toast } from 'react-toastify'
import { friendlyMessageFor } from '../../../utility/errorHelper'
import { Order } from '../../../models/Order'
import { getOrderDetail } from '../../../services/orderService'
import { formatToPrice } from '../../../utility/prettifynumber'
import { friendlyOrderItemStatus } from '../../../utility/orderHelper'
import { OrderItemStatus } from '../../../config/enums'

const OrderDetail: React.FC = () => {
  const { orderId } = useParams()
  const history = useHistory()
  const [order, setOrder] = useState<Order | undefined>(undefined)

  useEffect(() => {
    if (orderId) {
      getOrderDetail(orderId)
        .then(orderDetail => {
          setOrder(orderDetail)
        })
        .catch(err => {
          console.error(err)
          toast.error(friendlyMessageFor(err))
        })
    }
  }, [orderId])

  return (
    <Layout>
      <div data-testid="orderDetailFC">
        <Row>
          <Col xl={8} className="mx-auto">
            <Row>
              <Col>
                <h1 className="pageTitle">Order Detail</h1>
              </Col>
            </Row>

            <Row>
              <Col className="text-center text-dark mt-3">
                <h5>Order #: {order?.orderNumber}</h5>
              </Col>
            </Row>

            {order?.orderItems.map(orderItem => {
              return (
                <Row key={orderItem.item.id} data-testid="orderItem">
                  <Col className="itemRow">
                    <div className="itemRowSeparator" />
                    <div>
                      <img
                        className="itemRowThumbnail"
                        alt={orderItem.item.name}
                        src={orderItem.item.thumbImageUrl}
                      />
                    </div>
                    <div>
                      <h3 data-testid="itemTitle">{orderItem.item.name}</h3>
                    </div>
                    <div className="itemRowDescription">
                      <span data-testid="vendorName">
                        Vendor: {orderItem.vendor.name}
                      </span>
                      <br />
                      <span data-testid="variant">
                        {orderItem.item.variantName}
                      </span>
                      <br />
                      <span data-testid="quantity">
                        Quantity: {orderItem.quantity}
                      </span>
                      <br />
                      <span
                        className={
                          orderItem.status === OrderItemStatus.rejected
                            ? 'text-danger'
                            : 'text-success'
                        }
                        data-testid="status"
                      >
                        Order status:{' '}
                        {friendlyOrderItemStatus(orderItem.status)}
                      </span>
                    </div>
                    <div>
                      <span data-testid="price">
                        {order.installmentInfo ? (
                          <>
                            {formatToPrice(
                              orderItem.totalPrice / order.installmentInfo.term,
                              orderItem.currency
                            )}
                            /mo
                          </>
                        ) : (
                          <>
                            {formatToPrice(
                              orderItem.totalPrice,
                              orderItem.currency
                            )}
                          </>
                        )}
                      </span>
                    </div>
                    {orderItem.gift && (
                      <div>
                        <img
                          className="itemRowThumbnail itemRowGift"
                          alt={`gift: ${orderItem.gift.name}`}
                          src={orderItem.gift.thumbImageUrl}
                        />
                        <h4 data-testid="gift">GIFT: {orderItem.gift.name}</h4>
                      </div>
                    )}
                    <div className="text-center mt-4">
                      <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => {
                          history.push(`/shop/products/${orderItem.item.id}`)
                        }}
                        data-testid="viewItemButton"
                      >
                        View item
                      </Button>
                      {orderItem.status !== OrderItemStatus.rejected && (
                        <>
                          <br />
                          <Button
                            variant="light"
                            size="sm"
                            onClick={() => {
                              history.push(
                                `/orders/${orderId}/${orderItem.item.id}`
                              )
                            }}
                            className="mt-3"
                            data-testid="trackButton"
                          >
                            Track order
                          </Button>
                        </>
                      )}
                    </div>
                  </Col>
                </Row>
              )
            })}
          </Col>
        </Row>
      </div>
    </Layout>
  )
}

export default OrderDetail
